import logoHandyNew from "assets/images/logoHandNew.svg";
import logoRhino from "assets/images/logoRhino.png";
import { TIENDA_HANDY } from "config";
import { useWhiteLabelBranding } from "hooks/useWhiteLabelBranding";
import PropTypes from "prop-types";

import "./Logo.scss";

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ color }) => {
  const { isHandyStyle, logoUrl, brandName, isBrandingReady } = useWhiteLabelBranding();

  // Siempre mostrar algo, incluso si hay errores
  try {
    // Mientras se carga el branding, usar la lógica legacy
    if (!isBrandingReady) {
      return TIENDA_HANDY ? (
        <img src={logoHandyNew} alt="Handy Logo" style={{ maxWidth: "50px", height: "auto" }} />
      ) : (
        <img src={logoRhino} alt="Rhino Logo" style={{ maxWidth: "50px", height: "auto" }} />
      );
    }

    // Si hay un logo personalizado desde el branding, usarlo
    if (logoUrl && logoUrl !== "/favicon.png") {
      return <img src={logoUrl} alt={`${brandName} Logo`} style={{ maxWidth: "50px", height: "auto" }} />;
    }

    // Usar logos específicos según el tipo de marca
    if (isHandyStyle) {
      return <img src={logoHandyNew} alt="Handy Logo" style={{ maxWidth: "50px", height: "auto" }} />;
    }

    return <img src={logoRhino} alt="Rhino Logo" style={{ maxWidth: "50px", height: "auto" }} />;
  } catch (error) {
    // Fallback de emergencia
    return TIENDA_HANDY ? (
      <img src={logoHandyNew} alt="Handy Logo" style={{ maxWidth: "50px", height: "auto" }} />
    ) : (
      <img src={logoRhino} alt="Rhino Logo" style={{ maxWidth: "50px", height: "auto" }} />
    );
  }
};

Logo.propTypes = {
  color: PropTypes.string,
};

Logo.defaultProps = {
  color: "primary",
};

export default Logo;
